import { useLocation } from 'react-router-dom'

import { MAP_TYPES } from '../constants/constants'

/**
 * Hook which gets the current map type and subtype from the URL
 */
export function useMapType() {
  const query = new URLSearchParams(useLocation().search)
  const typeFromQuery = query.get('t')
  const subtypeFromQuery = query.get('st')

  const type = MAP_TYPES.find((t) => t.type === typeFromQuery) ?? MAP_TYPES[0]
  const subtype = type.subtypes.find((subtype) => subtype.id === subtypeFromQuery) ?? type.subtypes[0]

  return { type, subtype }
}
